import { api } from 'api/v1/api';

export type ChatReportReasons = Record<string, string>;

export type ChatReportCreatePayload = {
  chat_id: number;
  reason_code: string;
  reason_text?: string | null;
};

export type ChatReportOut = {
  id: number;
  chat_id: number;
  reason_code: string;
  reason_label: string;
  reason_text?: string | null;
  status: string;
  created_at: string;
};

export const getChatReportReasons = async (): Promise<ChatReportReasons> =>
  (await api.get<ChatReportReasons>('/chat/report-reasons/')).data;

export const createChatReport = async (
  payload: ChatReportCreatePayload,
): Promise<ChatReportOut> => (await api.post<ChatReportOut>('/chat/reports/', payload)).data;
